import { Box, Container, Typography, Paper, useTheme, alpha } from '@mui/material'
import LegalHero from './LegalHero'
import { motion } from 'framer-motion'

const PrivacyPolicy = () => {
  const theme = useTheme()

  return (
    <Box>
      <LegalHero
        title="Privacy Policy"
        subtitle="We value your privacy and are committed to protecting your personal information"
        lastUpdated="January 15, 2024"
      />
      
      <Container
        maxWidth="lg"
        component={motion.div}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        <Paper
          elevation={0}
          sx={{
            mt: -6,
            mb: 8,
            p: { xs: 3, md: 6 },
            borderRadius: 2,
            bgcolor: 'white',
            position: 'relative',
            zIndex: 3,
            boxShadow: `0 4px 24px ${alpha(theme.palette.common.black, 0.1)}`,
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
            Introduction
          </Typography>
          <Typography paragraph>
            At Bisworupa Inn, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or stay at our hotel.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }}>
            Information We Collect
          </Typography>
          <Typography paragraph>
            We collect information that you provide directly to us, including but not limited to:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                Personal identification information (Name, email address, phone number, etc.)
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Booking information (Check-in/out dates, room preferences, special requests)
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Payment information (Credit card details, billing address)
              </Typography>
            </li>
          </ul>

          {/* Add more sections as needed */}
        </Paper>
      </Container>
    </Box>
  )
}

export default PrivacyPolicy 